import { Injectable } from '@angular/core';

import { ILookup, LookupsService } from 'common';

@Injectable()
export class OrganisationTypeResolver  {
  constructor(private lookups: LookupsService) { }

  resolve() {
    return this.lookups.getPRSOrganisationTypes().toPromise();
  }
}
